// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import LandingPage from './components/LandingPage';
import MindWorkoutLanding from './components/mindworkout/MindWorkoutLanding';
import MindAttentionLanding from './components/mindattention/MindAttentionLanding';
import AppPortal from './components/portal/AppPortal';
import TermsOfService from './components/legal/TermsOfService';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import AccountDeletion from "./components/legal/AccountDeletion";
import WorkoutPrivacyPolicy from "./components/legal/WorkoutPrivacyPolicy";
import WorkoutTermsOfService from "./components/legal/WorkoutTermsOfService";
import WorkoutAccountDeletion from "./components/legal/WorkoutAccountDeletion";
import MindAttentionPrivacyPolicy from "./components/legal/MindAttentionPrivacyPolicy";
import MindAttentionTermsOfService from "./components/legal/MindAttentionTermsOfService";
import MindAttentionAccountDeletion from "./components/legal/MindAttentionAccountDeletion";
import MindAttentionToss from "./components/legal/MindAttentionToss";
import GrowBeyondTodayLanding from "./components/growbeyondtoday/GrowBeyondTodayLanding";
import GrowBeyondTodayTermsOfService from "./components/legal/GrowBeyondTodayTermsOfService";
import GrowBeyondTodayPrivacyPolicy from "./components/legal/GrowBeyondTodayPrivacyPolicy";
import GrowBeyondTodayAccountDeletion from "./components/legal/GrowBeyondTodayAccountDeletion";
import HealthCheckLanding from "./components/healthcheck/HealthCheckLanding";
import HealthCheckTermsOfService from "./components/legal/HealthCheckTermsOfService";
import HealthCheckPrivacyPolicy from "./components/legal/HealthCheckPrivacyPolicy";
import HealthCheckAccountDeletion from "./components/legal/HealthCheckAccountDeletion";
import IngredientCheckerPrivacyPolicy from "./components/legal/IngredientCheckerPrivacyPolicy";
import IngredientCheckerTermsOfService from "./components/legal/IngredientCheckerTermsOfService";
import IngredientCheckerAccountDeletion from "./components/legal/IngredientCheckerAccountDeletion";
import IngredientCheckerLanding from "./components/ingredientchecker/IngredientCheckerLanding";
import ArrowQuestLanding from "./components/arrowquest/ArrowQuestLanding";
import ArrowQuestPrivacyPolicy from "./components/legal/ArrowQuestPrivacyPolicy";
import ArrowQuestTermsOfService from "./components/legal/ArrowQuestTermsOfService";
import ArrowQuestAccountDeletion from "./components/legal/ArrowQuestAccountDeletion";
import CubiePopLanding from "./components/cubiepop/CubiePopLanding";
import CubiePopPrivacyPolicy from "./components/legal/CubiePopPrivacyPolicy";
import CubiePopTermsOfService from "./components/legal/CubiePopTermsOfService";
import CubiePopAccountDeletion from "./components/legal/CubiePopAccountDeletion";
import CryptCrawlerLanding from "./components/cryptcrawler/CryptCrawlerLanding";
import CryptCrawlerPrivacyPolicy from "./components/legal/CryptCrawlerPrivacyPolicy";
import CryptCrawlerTermsOfService from "./components/legal/CryptCrawlerTermsOfService";
import CryptCrawlerAccountDeletion from "./components/legal/CryptCrawlerAccountDeletion";

const GlobalStyle = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    body {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        line-height: 1.5;
    }

    html {
        scroll-behavior: smooth;
    }
`;

function App() {
    return (
        <Router>
            <GlobalStyle />
            <Routes>
                <Route path="/" element={<AppPortal />} />
                <Route path="/wellness" element={<LandingPage />} />
                <Route path="/workout" element={<MindWorkoutLanding />} />
                <Route path="/mindattention" element={<MindAttentionLanding />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/workout/terms" element={<WorkoutTermsOfService />} />
                <Route path="/workout/privacy" element={<WorkoutPrivacyPolicy />} />
                <Route path="/account-deletion" element={<AccountDeletion />} />
                <Route path="/workout/account-deletion" element={<WorkoutAccountDeletion />} />
                <Route path="/mindattention/terms" element={<MindAttentionTermsOfService />} />
                <Route path="/mindattention/privacy" element={<MindAttentionPrivacyPolicy />} />
                <Route path="/mindattention/account-deletion" element={<MindAttentionAccountDeletion />} />
                <Route path="/mindattention/toss" element={<MindAttentionToss />} />
                <Route path="/growbeyondtoday" element={<GrowBeyondTodayLanding />} />
                <Route path="/growbeyondtoday/terms" element={<GrowBeyondTodayTermsOfService />} />
                <Route path="/growbeyondtoday/privacy" element={<GrowBeyondTodayPrivacyPolicy />} />
                <Route path="/growbeyondtoday/account-deletion" element={<GrowBeyondTodayAccountDeletion />} />
                <Route path="/healthcheck" element={<HealthCheckLanding />} />
                <Route path="/healthcheck/terms" element={<HealthCheckTermsOfService />} />
                <Route path="/healthcheck/privacy" element={<HealthCheckPrivacyPolicy />} />
                <Route path="/healthcheck/account-deletion" element={<HealthCheckAccountDeletion />} />
                <Route path="/ingredientchecker" element={<IngredientCheckerLanding />} />
                <Route path="/ingredientchecker/terms" element={<IngredientCheckerTermsOfService />} />
                <Route path="/ingredientchecker/privacy" element={<IngredientCheckerPrivacyPolicy />} />
                <Route path="/ingredientchecker/account-deletion" element={<IngredientCheckerAccountDeletion />} />
                <Route path="/arrowquest" element={<ArrowQuestLanding />} />
                <Route path="/arrowquest/terms" element={<ArrowQuestTermsOfService />} />
                <Route path="/arrowquest/privacy" element={<ArrowQuestPrivacyPolicy />} />
                <Route path="/arrowquest/account-deletion" element={<ArrowQuestAccountDeletion />} />
                <Route path="/cubiepop" element={<CubiePopLanding />} />
                <Route path="/cubiepop/privacy" element={<CubiePopPrivacyPolicy />} />
                <Route path="/cubiepop/terms" element={<CubiePopTermsOfService />} />
                <Route path="/cubiepop/account-deletion" element={<CubiePopAccountDeletion />} />
                <Route path="/cryptcrawler" element={<CryptCrawlerLanding />} />
                <Route path="/cryptcrawler/privacy" element={<CryptCrawlerPrivacyPolicy />} />
                <Route path="/cryptcrawler/terms" element={<CryptCrawlerTermsOfService />} />
                <Route path="/cryptcrawler/account-deletion" element={<CryptCrawlerAccountDeletion />} />
            </Routes>
        </Router>
    );
}

export default App;
